module.exports = __webpack_public_path__ + "img/gray-info-icon.e283cae2.svg";